import { lazy } from 'react';

const NotFound = lazy(() => import('Containers/NotFound/NotFound'));

const routes = [
  {
    path: '*',
    exact: true,
    ContentComponent: NotFound,
  },
];

export default routes;
